const ME_TOKEN = '__me__';
export const isExcludeMode = (predicate)=>predicate.nin != null && predicate.nin.length > 0;
export const valueLabelFor = (predicate, t)=>{
    var _predicate_nin, _predicate_in;
    const values = isExcludeMode(predicate) ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [];
    return values.map((value)=>value === ME_TOKEN ? t.modifiedByValueMe() : value).join(', ');
};
export const currentValue = (predicate)=>{
    var _predicate_nin, _predicate_in;
    return (isExcludeMode(predicate) ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : []).join(', ');
};
